<nz-card [nzBodyStyle]="{ height: 'auto', position: 'relative' }" class="relative">
    <google-map height="80dvh" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions"
        (mapInitialized)="onMapReady($event)"></google-map>

    <nz-card class="glass-card absolute bottom-6 left-1/2 -translate-x-1/2 w-11/12 px-6 py-3 shadow-lg rounded-lg">
        <div class="flex flex-col gap-2 px-2">
            <nz-slider [nzMin]="minHour" [nzMax]="maxHour" [nzStep]="1" [nzRange]="false" [ngModel]="time"
                (nzOnAfterChange)="onTimeRangeChange($event)" [nzMarks]="hourMarks" [nzTooltipVisible]="'never'"
                class="w-full mx-auto">
            </nz-slider>
        </div>
    </nz-card>

    <nz-card class="glass-card absolute top-6 right-6 w-4/12 px-6 py-3 shadow-lg rounded-lg">
        <div class="flex flex-col gap-2 px-2">
            <app-aqi-status-bar [currentAqi]="currentAqi || 0"></app-aqi-status-bar>
        </div>
    </nz-card>
</nz-card>